export const SYSTEM_CONFIG = {
  backlog_size: 200,
  fast_timeout: 50,
};
export const PERFORM_CONFIG = {
  // 不能小于50
  textInitialDelay: 80,
};
